import { Checkbox, Heading, HeadingProps } from '@mm/components';
import { useChatbotCRUDActions } from '@mm/state/actions/ChatbotCRUDActions';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SettingSection from '../../../../components/SettingSection/SettingSection';
import './vips.pcss';

type Props = {
  withTitle?: boolean;
  className?: string;
  headingClassName?: string;
  headingSize?: 1 | 2 | 3 | 4 | 5 | 6;
};

export const VIPs = (props: Props) => {
  const { withTitle = true, className, headingSize, headingClassName } = props;
  const activeChatbot = useSelector(activeChatbotSelector);
  const chatbotCRUDActions = useChatbotCRUDActions();

  const [skipAutomationsForFollowed, setSkipAutomationsForFollowed] = useState(
    !!activeChatbot.messagesSettings?.skipAutomationsForFollowed,
  );

  const [skipAutomationsForVerified, setSkipAutomationsForVerified] = useState(
    !!activeChatbot.messagesSettings?.skipAutomationsForVerified,
  );

  useEffect(() => {
    if (
      skipAutomationsForFollowed !==
      activeChatbot.messagesSettings?.skipAutomationsForFollowed
    ) {
      setSkipAutomationsForFollowed(
        !!activeChatbot.messagesSettings?.skipAutomationsForFollowed,
      );
    }
  }, [activeChatbot.messagesSettings?.skipAutomationsForFollowed]);

  useEffect(() => {
    if (
      skipAutomationsForVerified !==
      activeChatbot.messagesSettings?.skipAutomationsForVerified
    ) {
      setSkipAutomationsForFollowed(
        !!activeChatbot.messagesSettings?.skipAutomationsForVerified,
      );
    }
  }, [activeChatbot.messagesSettings?.skipAutomationsForVerified]);

  return (
    <SettingSection
      title={withTitle ? 'Instagram: Don’t trigger Automations for VIPs' : ''}
      className={className}
    >
      <div className="settings-vips">
        <Checkbox
          isChecked={skipAutomationsForFollowed}
          onToggle={() => {
            chatbotCRUDActions.update({
              ...activeChatbot,
              messagesSettings: {
                ...activeChatbot.messagesSettings,
                skipAutomationsForFollowed: !skipAutomationsForFollowed,
              },
            });
            setSkipAutomationsForFollowed(!skipAutomationsForFollowed);
          }}
        />
        <Heading
          size={headingSize ? headingSize : 4}
          isBold={false}
          className={classNames('settings-vips-heading', headingClassName)}
        >
          Don’t trigger automations for people I Follow
        </Heading>
      </div>
      <div className="settings-vips">
        <Checkbox
          className="settings-vips__checkbox"
          isChecked={skipAutomationsForVerified}
          onToggle={() => {
            chatbotCRUDActions.update({
              ...activeChatbot,
              messagesSettings: {
                ...activeChatbot.messagesSettings,
                skipAutomationsForVerified: !skipAutomationsForVerified,
              },
            });
            setSkipAutomationsForVerified(!skipAutomationsForVerified);
          }}
        />
        <Heading
          size={headingSize ? headingSize : 4}
          isBold={false}
          className={classNames('settings-vips-heading', headingClassName)}
        >
          Don’t trigger automations for Verified Accounts
        </Heading>
      </div>
    </SettingSection>
  );
};
